import {
  CreateSystemUserRequest,
  DeleteSystemUserRequest,
  InitiatePasswordResetRequest,
  ResetPasswordRequest,
  UpdateSystemUserRequest,
  ViewSystemUserRequest
} from './system-user.types';

import {
  API_HOST,
  HttpDeleteOptions,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpDeleteOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/system-user`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreateSystemUserRequest = (
  data: CreateSystemUserRequest
): [string, HttpPostOptions<CreateSystemUserRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getViewSystemUserRequest = (data: ViewSystemUserRequest): [string, HttpGetOptions] => [
  getSpecificEndpoint(data.systemUserExternalReference),
  getHttpGetOptions()
];

export const getUpdateSystemUserRequest = (
  data: UpdateSystemUserRequest
): [string, HttpPutOptions<UpdateSystemUserRequest>] => [getEndpoint(), getHttpPutOptions(data)];

const getResetPasswordEndpoint = () => `${getEndpoint()}/reset-password`;

export const getInitiatePasswordResetRequest = (
  data: InitiatePasswordResetRequest
): [string, HttpPostOptions<InitiatePasswordResetRequest>] => [getResetPasswordEndpoint(), getHttpPostOptions(data)];

export const getResetPasswordRequest = (data: ResetPasswordRequest): [string, HttpPutOptions<ResetPasswordRequest>] => [
  getResetPasswordEndpoint(),
  getHttpPutOptions(data)
];

const getDeleteAccountEndpoint = (systemUserExternalReference: string) =>
  `${getEndpoint()}/delete-account/${systemUserExternalReference}`;
export const getDeleteAccountRequest = (data: DeleteSystemUserRequest): [string, HttpDeleteOptions] => [
  getDeleteAccountEndpoint(data.systemUserExternalReference),
  getHttpDeleteOptions()
];
